<template>
  <ImagePopup :isActive="isActive" :closePopupCallback="closePopupCallback">
    <div class="screenshot-slider"
         ref="slider"
         @touchstart="onTouchStart"
         @touchmove="onTouchMove"
         @touchend="onTouchEnd">
      <div class="screenshot-track"
           :style="trackStyle">
        <div v-for="(slide, index) in selectedTarotBox?.screenShotImgUrlList"
             :key="index"
             class="screenshot-slide"
             :style="{ width: sliderWidth + 'px' }">
          <img
              :src="slide"
              class="screenshot-image"
              alt="screenshot"/>
        </div>
      </div>
      <div class="slide-indicator" v-if="totalSlides > 1">
        {{ activeIndex + 1 }} / {{ totalSlides }}
      </div>
    </div>
  </ImagePopup>
</template>

<script>
import ImagePopup from "@/tarot_box/pages/home/components/tarot_box_detail/components/ImagePopup";
import {mapGetters} from "vuex";
import {logEvent} from "@/tarot_box/helper/native_api";
export default {
  name: "ScreenshotPopup",
  components: {ImagePopup},
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    closePopupCallback: {
      type: Function,
      required: true,
    },
    selectedTarotBox: {
      type: Object,
    },
    numberOfCarousel: {
      type: Number,
      required: true,
    },
    currentSlideIndex: {
      type: Number,
    }
  },
  data() {
    return {
      activeIndex: 0,
      startX: 0,
      currentX: 0,
      isDragging: false,
      dragOffset: 0,
      sliderWidth: 300,
    };
  },
  computed: {
    ...mapGetters(['user', 'categories', 'promotions', 'recommendTabs', 'tarotBoxes']),
    totalSlides() {
      return this.selectedTarotBox?.screenShotImgUrlList?.length || 0;
    },
    trackStyle() {
      const offsetPx = -(this.activeIndex * this.sliderWidth) + (this.isDragging ? this.dragOffset : 0);
      return {
        transform: `translateX(${offsetPx}px)`,
        transition: this.isDragging ? 'none' : 'transform 0.3s ease',
        width: (this.totalSlides * this.sliderWidth) + 'px',
      };
    },
  },
  watch: {
    currentSlideIndex(val) {
      this.activeIndex = val || 0;
    },
    isActive(val) {
      if (val) {
        this.activeIndex = this.currentSlideIndex || 0;
        this.$nextTick(() => {
          this.updateSliderWidth();
        });
      }
    }
  },
  methods: {
    updateSliderWidth() {
      const el = this.$refs.slider;
      if (el) {
        this.sliderWidth = el.offsetWidth;
      }
    },
    onTouchStart(e) {
      this.updateSliderWidth();
      this.startX = e.touches[0].clientX;
      this.isDragging = true;
      this.dragOffset = 0;
    },
    onTouchMove(e) {
      if (!this.isDragging) return;
      this.currentX = e.touches[0].clientX;
      this.dragOffset = this.currentX - this.startX;
    },
    onTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;

      const threshold = this.sliderWidth * 0.2;

      if (this.dragOffset < -threshold && this.activeIndex < this.totalSlides - 1) {
        this.activeIndex++;
        logEvent("snack_detail_shot_navi", {tarot_box_id: this.selectedTarotBox.id});
      } else if (this.dragOffset > threshold && this.activeIndex > 0) {
        this.activeIndex--;
        logEvent("snack_detail_shot_navi", {tarot_box_id: this.selectedTarotBox.id});
      }

      this.dragOffset = 0;
    },
  },
}
</script>

<style scoped>
.screenshot-slider {
  width: 100%;
  overflow: hidden;
  position: relative;
  touch-action: pan-y;
}

.screenshot-track {
  display: flex;
}

.screenshot-slide {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 3%;
}

.screenshot-image {
  max-width: 100%;
  max-height: 80svh;
  object-fit: contain;
  border-radius: 8px;
}

.slide-indicator {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 100px;
}
</style>
